class RcWishlistSync extends HTMLElement {

  constructor() {
    super();
    this.observer = null;
    this.primaryAnchor = null;
    this.proxyButton = null;
    this._onProxyClick = () => { this._forwardClick(); };
  };

  connectedCallback() { this._initialize(); };

  disconnectedCallback() { this._deinitialize(); };

  _initialize() {
    this.primaryAnchor = document.querySelector('.swym-custom-wishlist-anchor');
    this.proxyButton = this.querySelector('[data-wishlist-proxy]');
    if(!this.primaryAnchor || !this.proxyButton) return;

    this.proxyButton.addEventListener('click', this._onProxyClick);

    if(window.MutationObserver){
      this.observer = new MutationObserver(() => { this._syncState(); });
      this.observer.observe(this.primaryAnchor, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'aria-pressed', 'data-in-wishlist']
      });
    }

    this._syncState();
  };

  _deinitialize() {
    if(this.proxyButton) this.proxyButton.removeEventListener('click', this._onProxyClick);
    if(this.observer){ try { this.observer.disconnect(); } catch(e){} this.observer = null; }
  };

  _getRealButton() {
    return this.primaryAnchor ? this.primaryAnchor.querySelector('button.swym-icon-text') : null;
  };

  _forwardClick() {
    const realButton = this._getRealButton();
    if(realButton) realButton.click();
  };

  _isAdded(realButton) {
    if(!realButton) return false;
    // Swym marks an in-wishlist item with different classes depending on version
    // (swym-added on Wishlist Plus, swym-wishlist-added on some templates). Also
    // fall back to aria-pressed / data-in-wishlist so the filled state stays in
    // sync regardless of which signal Swym exposes.
    if(realButton.classList.contains('swym-added')) return true;
    if(realButton.classList.contains('swym-wishlist-added')) return true;
    if(realButton.getAttribute('aria-pressed') === 'true') return true;
    if(realButton.getAttribute('data-in-wishlist') === 'true') return true;
    return false;
  };

  _syncState() {
    if(!this.proxyButton) return;
    const realButton = this._getRealButton();
    this.proxyButton.disabled = !realButton;
    const added = this._isAdded(realButton);
    this.proxyButton.classList.toggle('wishlist-added', added);
    this.proxyButton.setAttribute('aria-pressed', String(added));
  };

}

if(!customElements.get('rc-wishlist-sync')) customElements.define('rc-wishlist-sync', RcWishlistSync);
